module.exports = __webpack_public_path__ + "static/media/mobile-promotion_content.ae4e2d75.png";